export const fastLinksMap = {
  payments: {
    id: 'payments',
    text: 'Pay or transfer money',
  },
  managePayments: {
    id: 'managepayments',
    text: 'View scheduled payments',
  },
  statementPreference: {
    id: 'stmtpref',
    text: 'Go paper-free',
  },
};
